import { render } from "./OurProjects.vue?vue&type=template&id=0b73e05a&scoped=true"
import script from "./OurProjects.vue?vue&type=script&lang=js"
export * from "./OurProjects.vue?vue&type=script&lang=js"

import "./OurProjects.vue?vue&type=style&index=0&id=0b73e05a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b73e05a"]])

export default __exports__